import axios from "axios";
import { store } from "../store/store";
import { setSessionExpired } from "../features/auth/authSlice";

// Global response interceptor: when any API call comes back 401/403 for a
// logged-in user (token present), the JWT is expired/invalid — surface the
// global "session expired" modal instead of each page handling it inline.
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error?.response?.status;
    const hasToken = !!localStorage.getItem("token");
    if (hasToken && (status === 401 || status === 403)) {
      store.dispatch(setSessionExpired(true));
    }
    return Promise.reject(error);
  },
);
